import React from 'react';
import { Card, Row, Col, Typography } from 'antd';
import DoughnutChartCard from '../DoughnutChartCard';

const { Title } = Typography;

interface DoughnutChartsSectionProps {
  title: 'Encaissement' | 'Paiement';
  chartsData: { title: string; data: { name: string; value: number }[]; colors: string[] }[];
}

const DoughnutChartsSection: React.FC<DoughnutChartsSectionProps> = ({ title, chartsData }) => {
  return (
    <Card style={{ background: '#fafafa' }}>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Title level={4}>{title}</Title>
        </Col>
        {chartsData.map((chart, index) => (
          <DoughnutChartCard key={index} title={chart.title} data={chart.data} colors={chart.colors} />
        ))}
      </Row>
    </Card>
  );
};

export default DoughnutChartsSection;
